export const PARENT_FONT_SIZE_PX = 20;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/constants/renderer.js